import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule, ValidationErrors } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormErrorComponent } from '../form-error/form-error.component';
import { FormLabelComponent } from '../form-label/form-label.component';

@Component({
    selector: 'input-number-fc',
    standalone: true,
    imports: [FormLabelComponent, FormErrorComponent, InputNumberModule, ReactiveFormsModule, TranslateModule],
    templateUrl: './input-number-fc.component.html',
    styleUrl: './input-number-fc.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputNumberFcComponent {
    private translate = inject(TranslateService);

    id = input.required<string>();
    control = input.required<FormControl>();

    label = input<string>('');
    tooltipText = input<string>('');
    required = input<boolean>(false);

    placeholder = input<string>('uiKit.form.inputNumber.placeholder');
    name = input<string>(''); //used for validation messages, if there is no label
    size = input<'small' | 'large'>('large');

    showError = input<boolean>(false);

    showButtons = input<boolean>(true);
    buttonLayout = input<'horizontal' | 'vertical'>('horizontal');

    step = input<number>(1);
    min = input<number>(0);
    max = input<number>(9999);

    onInput = output<void>();

    readonly errorMessages: Record<string, (label: string, control: FormControl, error: any) => string> = {
        required: () => `${this.translate.instant('uiKit.form.inputNumber.emptyNumberFormValidator')}`,
        min: (label, control) =>
            `${label} ${this.translate.instant('uiKit.form.inputNumber.minNumberFormValidator', {
                limit: control.errors?.['min'].min,
            })}`,
        max: (label, control) =>
            `${label} ${this.translate.instant('uiKit.form.inputNumber.maxNumberFormValidator', {
                limit: control.errors?.['max'].max,
            })}`,
    };

    getErrorMessage(error: string): string {
        const label = this.label() ? this.label() : this.name();

        return this.errorMessages[error]
            ? this.errorMessages[error](
                  this.translate.instant(label),
                  this.control(),
                  this.control().errors && this.control().errors?.[error]
              )
            : '';
    }

    getErrorKeys(errors: ValidationErrors | null): string[] {
        return errors ? Object.keys(errors) : [];
    }
}
